module.exports = "/_next/static/images/2703580515ccebdf52e9ccd37aa55b26-cajita-lg.png.webp";